import { useNavigate } from "react-router-dom";
import { TriangleAlert } from "lucide-react";
import { Button } from "@/ui";
import { useEngineQuery } from "@/engine/hooks";
import s from "../shared.module.css";

/**
 * Connections that stopped and only the member can restart: Google or Microsoft 365 ending Hub's access (Google does
 * every 7 days while the app is in testing), or the Mac losing Full Disk Access. One line per source, on Home, so it
 * is seen without opening Settings.
 */
export function NeedsAttention() {
  const navigate = useNavigate();
  const integrations = useEngineQuery("getIntegrations", undefined);
  const stopped = (integrations.data ?? []).filter((i) => i.status === "needs_attention" && !i.archived);
  // An account's three rows (contacts, mail, calendar) carry the same message; show it once.
  const lines = [...new Map(stopped.map((i) => [`${i.provider}:${i.remoteId ?? ""}:${i.lastError ?? ""}`, i])).values()];
  if (!lines.length) return null;
  return (
    <section className={s.section} data-testid="home-needs-attention">
      <div className={s.stat} style={{ borderColor: "var(--warning)" }}>
        <div className="u-row" style={{ gap: 6, fontWeight: 600, marginBottom: 4 }}><TriangleAlert size={14} /> A connection needs you</div>
        {lines.map((i) => (
          <div key={i.id} className="u-small u-muted" style={{ marginBottom: 4 }}>
            {i.remoteId ? `${i.remoteId}: ` : `${i.name ?? i.provider}: `}{i.lastError ?? "Open Settings to turn it back on."}
          </div>
        ))}
        <Button size="sm" variant="primary" style={{ marginTop: 6 }} onClick={() => navigate("/settings/integrations")}>Open Settings</Button>
      </div>
    </section>
  );
}
